import { cn } from '@perch/ui-tokens';

interface PerchLogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  className?: string;
}

const sizeConfig = {
  sm: { icon: 'w-7 h-7', text: 'text-lg', gap: 'gap-2' },
  md: { icon: 'w-9 h-9', text: 'text-xl', gap: 'gap-2.5' },
  lg: { icon: 'w-12 h-12', text: 'text-2xl', gap: 'gap-3' },
} as const;

export function PerchLogo({ size = 'md', showText = true, className }: PerchLogoProps) {
  const cfg = sizeConfig[size];
  return (
    <div className={cn('flex items-center', cfg.gap, className)}>
      <img src="/perch-icon.png" alt="Perch" className={cn(cfg.icon, 'object-contain')} />
      {showText && (
        <span className={cn(cfg.text, 'font-serif text-stone-900 dark:text-stone-100')}>
          Perch
        </span>
      )}
    </div>
  );
}
